import { trigger, transition, style, animate, keyframes } from '@angular/animations';


export const GrowUp = [
    trigger('growUp', [
        transition(':enter', [
            style({transform: 'scale(0.7)', opacity: 0}),
            animate('0.15s', style({transform: 'scale(1)', opacity: 1}))
        ]),

        transition(':leave', [
          animate('0.15s', style({transform: 'scale(0.7)', opacity: 0}))
        ])
    ])
];
